// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

const Backdrop = ({ baseClassName, className, innerRef, ...props }) => (
    <div
        ref={innerRef}
        className={classNames(baseClassName, className)}
        {...props}
    />
);
Backdrop.propTypes = {
    /**
     * Inner ref handler.
     */
    innerRef: PropTypes.func,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
Backdrop.defaultProps = {
    innerRef: null,
    baseClassName: `${CLS_PREFIX}overlay__backdrop`,
    className: null,
};

export default Backdrop;



// WEBPACK FOOTER //
// ./components/Overlay/Backdrop.js